import { Flex } from '@chakra-ui/react';
import React from 'react';
import ColumnSorterIcon from './ColumnSorterIcon';
const ColumnSorter = ({ sortField, onSort, currentSortOptions, }) => (React.createElement(Flex, { w: 6, onClick: () => onSort?.(sortField), "data-testid": "column_sorter" },
    React.createElement(ColumnSorterIcon, { sortField: sortField, currentSortOptions: currentSortOptions })));
export default ColumnSorter;
